const nucleotides = ["A", "C", "T", "G"];
const windowSize = 5;
const sequenceLength = 30000;

export { nucleotides, windowSize, sequenceLength };
